import React, { Component } from 'react';
import SelectPerson from './SelectPerson';
import Header from './Header';
import Note from './Note';
import Footer from './Footer';
import aes from 'crypto-js/aes';
import cryptojs from 'crypto-js';
import './scss/styles.scss';
import axios from 'axios';
import SecretSanta from './SecretSanta'


class Login extends Component {
	componentDidMount(callback) {
		axios.get(`${window.location.protocol}//${window.location.hostname}/api/users`)
			.then(res => {
				let items = res.data;
				if (!!callback) {
					callback(items);
				}
				return this.setState({ people: items })

			})

			.catch(err => {
				console.log(err);
				let items = { result: 'error', error: err }

				if (!!callback) {
					callback(items);
				}
			})
	}

	constructor(props) {
		super(props);

		this.state = {
			people: [],

			// people: [
			// 	"Arh",      // 0
			// 	"Катя",     // 1
			// 	"Михалыч",  // 2
			// 	"Ульяна",   // 3
			// 	"Юрич",     // 4
			// 	"Алёна",    // 5
			// 	"Никита",   // 6
			// 	"Елена", 		// 7
			// 	"Fenuks",   // 8				
			// 	"Леонид",		// 9
			// 	"Юлия",			// 10
			// 	"Андрей",		// 11
			// 	"Юлия Вейт",// 12
			// 	"Григорий"  // 13
			// ],
			santas: [],
			copied: false,
			hidden: true,
			message: "",
			params: this.getSearchParameters()
		};
	}

	encryptString(string) {
		const key = process.env.REACT_APP_ENCRYPT_KEY
		// const key = process.env.REACT_APP_ENCRYPT_KEY = '123456789abcdefg'
		return aes.encrypt(string, key)
	}

	decryptHash(hash) {
		const key = process.env.REACT_APP_ENCRYPT_KEY
		// const key = process.env.REACT_APP_ENCRYPT_KEY = '123456789abcdefg'
		const plaintext = aes.decrypt(hash.toString(), key)
		return plaintext.toString(cryptojs.enc.Utf8)
	}

	transformToArray(prmstr) {
		let params = {};
		let prmarr = prmstr.split("&");
		for (let i = 0; i < prmarr.length; i++) {
			let tmparr = prmarr[i].split("=");
			params[tmparr[0]] = tmparr[1];
		}
		return params;
	}

	getSearchParameters() {
		let prmstr = window.location.search.substr(1);
		return prmstr !== null && prmstr !== "" ? this.transformToArray(prmstr) : {};
	}

	shuffleArray(array) { // Sattolo's algorithm
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * i);
			const temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}

	handleAddPersonParent = (name) => {
		name = name.toLowerCase();
		console.log(name)
		if (name === "") {
			this.setState({
				hidden: false,
				message: "Please enter a valid name!"
			})
		}
		else if (this.state.people.indexOf(name) !== -1) { // -1 means in array
			this.setState({
				hidden: false,
				message: "This person has already been added!"
			})
		}
		else { // if not blank AND not in array already
			this.setState((prevState) => {
				return {
					hidden: true,
					people: prevState.people.concat(name),
					santas: []
				}
			})
		}
		console.log('this.state.people', this.state.people)
	}

	handleDeletePerson = (name) => {
		this.setState((prevState) => {
			return {
				people: prevState.people.filter(item => item !== name)
			}
		})
	}

	handleGenerate = () => {
		const peoples = this.state.people.map(el => el.name);
		const newArray = this.state.people.map(el => el.name); // copy array
		const santas = this.shuffleArray(newArray);

		if (this.state.people.length <= 2) {
			this.setState({
				hidden: false,
				message: "You need at least 3 people to generate Secret Santas!"
			})
		} else {
			let exec = true;

			this.state.people.map((person, index) => {
				person.exec.map((execPerson, index) => {
					if (santas.indexOf(person.name) === peoples.indexOf(execPerson)) {
						console.warn('%cALARM', 'color: orange', 'Exception', person.name, execPerson);
						exec = false;
					}
				})
			})

			if (exec) {
				this.setState(() => {
					return {
						hidden: true,
						santas: santas
					}
				})
			} else {
				this.handleGenerate()
			}
		}
	}

	handleUpdateUsers = () => {
		let santas = this.state.santas
		axios.post(`${window.location.protocol}//${window.location.hostname}/api/santas/${santas}`)
			.then(function (response) {
				console.log(response);
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	takeSantaPage = () => {
		const paramLogin = decodeURI(this.state.params.login).replace("%", " ");
		const paramPassword = this.state.params.password;

		function dh(hash) {
			const key = process.env.REACT_APP_ENCRYPT_KEY
			const plaintext = aes.decrypt(hash.toString(), key)
			return plaintext.toString(cryptojs.enc.Utf8)
		}

		const login = this.state.people.find(function (item) {
			return item.name === paramLogin && dh(item.password) === paramPassword;
		});

		if (this.state.params.admin && this.state.params.pw === 'BurnToBeFile') {
			return (
				<React.Fragment>
					<SecretSanta />
				</React.Fragment>
			)
		}

		if (login) {
			const santaFor = this.state.people.find(function (item) {
				return item.name === dh(login.santa);
			});

			return (
				<div className="container">
					<Header />
					<Note login={login} name={login.name} mykey={login.santa} wishlist={santaFor.wishlist} decryptHash={this.decryptHash} />
				</div>
			)
		} else {
			return (
				<div className="body-wrap">
					<div className="container wrap">
						<Header />

						<SelectPerson handleAddPersonParent={this.handleAddPersonParent} options={this.state.people} />
					</div>

					<div className="container">
						<Footer />
					</div>
				</div>
			)
		}
	}

	render() {
		if (this.state.params.name !== undefined) {
			return (
				<div className="container">
					<Header />
					<Note name={this.state.params.name} mykey={this.state.params.key} decryptHash={this.decryptHash} />
				</div>
			)
		}

		return (
			<React.Fragment>
				{this.takeSantaPage()}
			</React.Fragment>
		);
	}
}

export default Login;
